import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import config from './config';
import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enNavbar from './locales/en/navbar.json';
import enSeo from './locales/en/seo.json';

const supportedLngs = config.languages;
const initialNamespaces = ['common', 'home', 'navbar', 'seo'];
const namespaceFiles = {
    localGuide: 'local-guide',
    houseRules: 'house-rules',
};

const englishResources = {
    common: enCommon,
    home: enHome,
    navbar: enNavbar,
    seo: enSeo,
};

const loadLocale = (language, namespace) => {
    const file = namespaceFiles[namespace] || namespace;
    return import(`./locales/${language}/${file}.json`).then((module) => module.default || module);
};

const lazyLocaleBackend = {
    type: 'backend',
    init: () => {},
    read: (language, namespace, callback) => {
        loadLocale(language, namespace)
            .catch((error) => {
                if (language !== 'en') {
                    return loadLocale('en', namespace);
                }

                throw error;
            })
            .then((resources) => callback(null, resources))
            .catch((error) => callback(error, false));
    },
};

i18n
    .use(lazyLocaleBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: englishResources,
        },
        partialBundledLanguages: true,
        supportedLngs,
        nonExplicitSupportedLngs: true,
        load: 'languageOnly',
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',

        ns: initialNamespaces,
        defaultNS: 'common',

        interpolation: {
            escapeValue: false,
        },

        detection: {
            // The URL language prefix (/en, /de, …) is the source of truth, so
            // read it first (path segment 0). Fall back to the visitor's saved
            // choice, then their browser. Bare URLs have no language segment, so
            // 'path' simply yields no match and detection continues down the list.
            order: ['path', 'localStorage', 'navigator'],
            lookupFromPathIndex: 0,
            caches: ['localStorage']
        },

        react: {
            useSuspense: true,
        }
    });

export default i18n;
